<template>
  <div>
    <!-- Escritorio -->
    <template v-if="$vuetify.breakpoint.mdAndUp">
      <v-row class="mb-2">
        <v-col cols="12" class="text-right">
          <v-btn
            v-if="canShowEditButton"
            rounded
            dark
            class="common-botton"
            @click="changeToEdit"
          >
            <span style="padding-right: 8px;">Editar</span>
            <v-icon right>mdi-pencil</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="3">
          <span class="text-header-data">Rol</span><br />
          <span>{{ rolNombre }}</span>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <span class="text-header-data">Fecha de ingreso</span><br />
          <span>{{ personalData.fecha_ingreso || "Sin llenar" }}</span>
        </v-col>

        <v-col cols="12" sm="6" md="3" v-if="hasTurno">
          <span class="text-header-data">Turno</span><br />
          <span>{{ turnoLabel }}</span>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <span class="text-header-data">Ramo</span><br />

          <!-- Tiene ramos -->
          <template v-if="personalData.ramos && personalData.ramos.length">
            <span class="pill-tag">
              {{ getRamoLabel() }}
            </span>
            <span v-if="personalData.ramos.length > 1" class="pill-extra">
              (+{{ personalData.ramos.length - 1 }} más)
            </span>
          </template>

          <!-- No tiene ramos -->
          <span v-else>Sin asignar</span>
        </v-col>


        <v-col  cols="12"
                sm="6"
                md="3" >
          <span class="text-header-data">Call Center</span><br />
          <span>{{ callCenterName }}</span>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="3"
          v-if="personalData.rol === 'VALIDADORCC'"
        >
          <span class="text-header-data">Extensión</span><br />
          <span>{{ personalData.extension || "Sin llenar" }}</span>
        </v-col>

        <!-- <v-col cols="12" sm="6" md="3">
          <span class="text-header-data">Canal</span><br />

          <template
            v-if="
              (personalData.canales && personalData.canales.length) ||
                (personalData.canal && personalData.canal.length)
            "
          >
            <span class="pill-tag">
              {{ getCanalLabel() }}
            </span>
            <span
              v-if="
                (personalData.canales && personalData.canales.length > 1) ||
                  (personalData.canal && personalData.canal.length > 1)
              "
              class="pill-extra"
            >
              (+{{ (personalData.canales || personalData.canal).length - 1 }}
              más)
            </span>
          </template>

          <span v-else>Sin asignar</span>
        </v-col> -->

        <v-col
          cols="12"
          sm="6"
          md="3"
          v-if="personalData.landings && personalData.landings.length"
        >
          <span class="text-header-data">Campaña</span><br />

          <span class="pill-tag">
            {{ getCampaniaLabel() }}
          </span>
          <span v-if="personalData.landings.length > 1" class="pill-extra">
            (+{{ personalData.landings.length - 1 }} más)
          </span>
        </v-col>

        <v-col cols="12" sm="6" md="3" v-if="isPostVentaRol">
          <span class="text-header-data">Áreas de negocio</span><br />

          <template v-if="hasAreasNegocio">
            <span class="pill-tag">{{ getAreaNegocioLabel() }}</span>
            <span v-if="areasNegocioIds.length > 1" class="pill-extra">
              (+{{ areasNegocioIds.length - 1 }} más)
            </span>
          </template>

          <span v-else>Sin asignar</span>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <span class="text-header-data">Área</span><br />
          <span class="pill-tag">{{ areaLabel }}</span>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <span class="text-header-data">Estatus</span><br />
          <span>
            <v-icon small :color="estatusAsignacionColor">mdi-circle</v-icon>
            {{ estatusAsignacionLabel }}
          </span>
        </v-col>

        <v-col cols="12" sm="6" md="3" v-if="showEmpresas">
          <span class="text-header-data">Empresas</span><br />

          <template
            v-if="personalData.empresas && personalData.empresas.length"
          >
            <span class="pill-tag">
              {{ getEmpresaLabel() }}
            </span>
            <span v-if="personalData.empresas.length > 1" class="pill-extra">
              (+{{ personalData.empresas.length - 1 }} más)
            </span>
          </template>

          <span v-else>Sin asignar</span>
        </v-col>

        <v-col cols="12" sm="6" md="3" v-if="showCuentasCorreo">
          <span class="text-header-data">Cuentas correo</span><br />

          <template
            v-if="
              personalData.cuentas_correo && personalData.cuentas_correo.length
            "
          >
            <span class="pill-tag">
              {{ getCuentaCorreoLabel() }}
            </span>
            <span
              v-if="personalData.cuentas_correo.length > 1"
              class="pill-extra"
            >
              (+{{ personalData.cuentas_correo.length - 1 }} más)
            </span>
          </template>

          <span v-else>Sin asignar</span>
        </v-col>
      </v-row>
    </template>

    <!-- Móvil -->
    <template v-else>
      <div class="mobile-container">
        <v-row>
          <v-col cols="12">
            <span class="text-header-data">Rol</span><br />
            <span>{{ rolNombre }}</span>
          </v-col>

          <v-col cols="12">
            <span class="text-header-data">Fecha de ingreso</span><br />
            <span>{{ personalData.fecha_ingreso || "Sin llenar" }}</span>
          </v-col>

          <v-col cols="12" v-if="hasTurno">
            <span class="text-header-data">Turno</span><br />
            <span>{{ turnoLabel }}</span>
          </v-col>

          <v-col cols="12" v-if="personalData.rol === 'VALIDADORCC'">
            <span class="text-header-data">Extensión</span><br />
            <span>{{ personalData.extension || "Sin llenar" }}</span>
          </v-col>

          <v-col cols="12">
            <span class="text-header-data">Ramo</span><br />
            <span>{{ ramoPrincipal }}</span>
          </v-col>

          <!-- <v-col cols="12">
            <span class="text-header-data">Canal</span><br />
            <span>{{ canalesTexto }}</span>
          </v-col> -->

          <v-col cols="12">
            <span class="text-header-data">Campaña</span><br />
            <span>{{ campaniaPrincipal }}</span>
          </v-col>

          <v-col cols="12" v-if="shouldShowAreasNegocio">
            <span class="text-header-data">Áreas de negocio</span><br />
            <span v-if="hasAreasNegocio">{{ areasNegocioTexto }}</span>
            <span v-else>Sin asignar</span>
          </v-col>

          <v-col cols="12">
            <span class="text-header-data">Área</span><br />
            <span>{{ areaLabel }}</span>
          </v-col>

          <v-col cols="12">
            <span class="text-header-data">Estatus</span><br />
            <span>
              <v-icon small :color="estatusAsignacionColor">mdi-circle</v-icon>
              {{ estatusAsignacionLabel }}
            </span>
          </v-col>

          <v-col cols="12" v-if="showEmpresas">
            <span class="text-header-data">Empresas</span><br />
            <span>{{ empresasTexto }}</span>
          </v-col>

          <v-col cols="12" v-if="showCuentasCorreo">
            <span class="text-header-data">Cuentas correo</span><br />
            <span>{{ cuentasCorreoTexto }}</span>
          </v-col>

          <v-col cols="12" v-if="canEdit">
            <v-btn
              rounded
              dark
              class="mobile-action-button"
              @click="changeToEdit"
            >
              <span>Editar</span>
              <v-icon right>mdi-pencil</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    personalData: {
      type: Object,
      default: () => ({}),
    },
    listings: {
      type: Object,
      default: () => ({
        ramoList: [],
        landings: [],
        roles: [],
        empresas: [],
        areasNegocios: [],
        areasAgente: [],
        estatusAsignacion: [],
      }),
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    rolNombre() {
      const rol = this.listings.roles.find(
        (r) => r.id === this.personalData.rol,
      );
      if (rol && rol.nombre) return rol.nombre;
      return this.personalData.rol || "Sin asignar";
    },
    callCenterName() {
      const callCenter = this.listings.callCenter.find(
          (c) => c.id === this.personalData.callCenter,
      );
      console.log("Checking call center", this.listings.callCenter)
      if (callCenter && callCenter.nombre) return callCenter.nombre;
      return this.personalData.callCenter || "Sin asignar";
    },
    ramoPrincipal() {
      const ids = this.personalData.ramos || [];
      if (!ids.length) return "Sin asignar";

      const firstId = ids[0];
      const ramo = this.listings.ramoList.find((r) => r.id === firstId);
      const label =
        (ramo && (ramo.etiqueta || ramo.ramo || ramo.name)) || firstId;
      const extra = ids.length > 1 ? ` (+${ids.length - 1} más)` : "";
      return label + extra;
    },
    campaniaPrincipal() {
      const ids = this.personalData.landings || [];
      if (!ids.length) return "Sin asignar";

      const firstId = ids[0];
      const camp = this.listings.landings.find((c) => c.id === firstId);
      const label =
        (camp && (camp.landing || camp.name || camp.nombre)) || firstId;
      const extra = ids.length > 1 ? ` (+${ids.length - 1} más)` : "";
      return label + extra;
    },
    // areasNegocioTexto() {
    //   const ids = this.personalData.areas_negocio || [];
    //   if (!ids.length) return "Sin asignar";
    //   const firstId = ids[0];
    //   const area = this.listings.areasNegocios.find((a) => a.id === firstId);
    //   const label = (area && area.nombre) || firstId;
    //   const extra = ids.length > 1 ? ` (+${ids.length - 1} más)` : "";
    //   return label + extra;
    // },
    showEmpresas() {
      return this.isPostVentaRol;
    },
    empresasTexto() {
      const items = this.personalData.empresas || [];
      if (!items.length) return "Sin asignar";

      const first = items[0];
      let label = "";

      // Caso 1: viene como objeto
      if (first && typeof first === "object") {
        label = first.empresa || first.nombre || first.name || first.id;
      } else {
        // Caso 2: viene como ID (number/string)
        const emp = this.listings.empresas.find((e) => e.id === first);
        label = (emp && (emp.empresa || emp.nombre || emp.name)) || first;
      }

      const extra = items.length > 1 ? ` (+${items.length - 1} más)` : "";
      return `${label}${extra}`;
    },
    showCuentasCorreo() {
      return this.isPostVentaRol;
    },
    cuentasCorreoTexto() {
      const cuentas = this.personalData.cuentas_correo || [];
      if (!cuentas.length) return "Sin asignar";

      const first = cuentas[0];
      let label = "";

      if (first && typeof first === "object") {
        label = first.cuenta || first.nombre || first.id;
      } else {
        // string o algo simple
        label = first;
      }

      const extra = cuentas.length > 1 ? ` (+${cuentas.length - 1} más)` : "";
      return `${label}${extra}`;
    },
    showLandings() {
      const rol = this.personalData.rol || "";
      // misma lógica que el legacy (sin routesConfig.completeData)
      return rol === "ADMINCC" || rol === "MANAGERCC" || rol === "AGENTCC";
    },
    landingsTexto() {
      const ids = this.personalData.landings || [];
      if (!ids.length) return "Sin asignar";

      const firstId = ids[0];
      const camp = this.listings.landings.find((c) => c.id === firstId);
      const label =
        (camp && (camp.landing || camp.name || camp.nombre)) || firstId;
      const extra = ids.length > 1 ? ` (+${ids.length - 1} más)` : "";
      return label + extra;
    },
    canalesTexto() {
      const ids = this.personalData.canales || this.personalData.canal || [];
      if (!ids.length) return "Sin asignar";

      const firstId = ids[0];
      const canalList = this.listings.canalList || [];
      const canal = canalList.find((c) => c.id === firstId);

      const label =
        (canal && (canal.etiqueta || canal.nombre || canal.name)) || firstId;
      const extra = ids.length > 1 ? ` (+${ids.length - 1} más)` : "";
      return label + extra;
    },
    hasTurno() {
      const t = (this.personalData.turno || "").toString().trim();
      return t.length > 0;
    },
    hasCallCenter(){
      const c = (this.personalData.callCenter ?? "").toString().trim();
      return c.length > 0;
    },
    hasCampania() {
      return (
        Array.isArray(this.personalData.landings) &&
        this.personalData.landings.length > 0
      );
    },
    areasNegocioIds() {
      const arr = Array.isArray(this.personalData.areas_negocio)
        ? this.personalData.areas_negocio
        : [];

      // limpia basura: null, undefined, "", 0, "0"
      return arr
        .map((x) => (x === "" ? null : x))
        .filter((x) => x !== null && x !== undefined)
        .map((x) => Number(x))
        .filter((x) => !Number.isNaN(x) && x !== 0);
    },

    hasAreasNegocio() {
      return this.areasNegocioIds.length > 0;
    },

    areasNegocioTexto() {
      if (!this.hasAreasNegocio) return "";

      const firstId = this.areasNegocioIds[0];
      const list = Array.isArray(this.listings.areasNegocios)
        ? this.listings.areasNegocios
        : [];

      // Si aún no cargó el catálogo, no muestres el ID
      if (!list.length) {
        const extra =
          this.areasNegocioIds.length > 1
            ? ` (+${this.areasNegocioIds.length - 1} más)`
            : "";
        return `Cargando...${extra}`;
      }

      const area = list.find((a) => Number(a.id) === Number(firstId));
      const label = (area && area.nombre) || "Sin asignar";

      const extra =
        this.areasNegocioIds.length > 1
          ? ` (+${this.areasNegocioIds.length - 1} más)`
          : "";

      return `${label}${extra}`;
    },
    turnoLabel() {
      const map = {
        1: "Matutino",
        2: "Vespertino",
        3: "Completo",
      };

      const t = this.personalData.turno;

      // si viene como número o string numérico
      const num = Number(t);
      if (!Number.isNaN(num) && map[num]) return map[num];

      // si por alguna razón ya viene texto
      if (typeof t === "string" && t.trim()) return t;

      return "Sin asignar";
    },
    isPostVentaRol() {
      const sel = (this.listings.roles || []).find(
        (r) => r.id === this.personalData.rol,
      );
      const nombre = (sel?.nombre || "").toString().toUpperCase();
      const rolId = (this.personalData.rol || "").toString().toUpperCase();

      const nombreNormalizado = nombre.replace(/[\s\-_]/g, "");
      const rolIdNormalizado = rolId.replace(/[\s\-_]/g, "");

      return (
        nombreNormalizado.includes("POSTVENTA") ||
        rolIdNormalizado.includes("POSTVENTA")
      );
    },

    shouldShowAreasNegocio() {
      return this.hasAreasNegocio || this.isPostVentaRol;
    },

    // Área del agente (PBP-2018, catálogo fijo distinto de "Áreas de negocio")
    areaLabel() {
      const found = (this.listings.areasAgente || []).find(
        (a) => a.id === this.personalData.area,
      );
      return found?.name || "Sin asignar";
    },

    // Estatus de asignación (PBP-2018)
    estatusAsignacionItem() {
      const code = this.personalData.estatusAsignacion ?? 1;
      return (this.listings.estatusAsignacion || []).find(
        (e) => e.id === code,
      );
    },
    estatusAsignacionLabel() {
      return this.estatusAsignacionItem?.name || "Activo";
    },
    estatusAsignacionColor() {
      return this.estatusAsignacionItem?.color || "#4caf50";
    },

    areaNegocioLabel() {
      if (!this.hasAreasNegocio) return "Sin asignar";
      return this.getAreaNegocioLabel();
    },

    areasNegociosFiltradas() {
      if (!this.canViewEmails) return this.areasNegocios;
      if (!this.isPostVentaRol) return this.areasNegocios;

      return (this.areasNegocios || []).filter((a) =>
        (a.nombre || "")
          .toString()
          .toUpperCase()
          .includes("ECI - POST-VENTA"),
      );
    },
    loggedRol() {
      try {
        return JSON.parse(localStorage.getItem("roles"))?.[0]?.rol || null;
      } catch (e) {
        return null;
      }
    },

    canShowEditButton() {
      // roles que SÍ pueden editar
      const allowed = [
        "ADMIN",
        "ADMINCC",
        "MANAGERCC",
        "MANAGERCCALIANZAS",
        "GERENTEPOSTVENTA",
        "MANAGEREMAILS",
        "MANAGERINBOUND",
        "OPERACIONESEMAILS",
        "OPERACIONESINBOUND",
      ];

      const editor = (this.loggedRol || "").toString().trim();
      const target = (this.personalData?.rol || "").toString().trim();

      // si el padre ya bloqueó edición, respetarlo
      if (!this.canEdit) return false;

      // si no está en lista, no puede
      if (!allowed.includes(editor)) return false;

      // si el rol a editar es el mismo que el logueado, NO puede
      // EXCEPTO ADMIN y ADMINCC
      if (editor === target && editor !== "ADMIN" && editor !== "ADMINCC") {
        return false;
      }

      return true;
    },
  },
  methods: {
    changeToEdit() {
      this.$emit("changeComponent", 2);
    },
    getRamoLabel() {
      const ids = this.personalData.ramos || [];
      if (!ids.length) return "";

      const firstId = ids[0];
      const ramo = this.listings.ramoList.find((r) => r.id === firstId);
      return (ramo && (ramo.etiqueta || ramo.ramo || ramo.name)) || firstId;
    },

    getCampaniaLabel() {
      const ids = this.personalData.landings || [];
      if (!ids.length) return "";

      const firstId = ids[0];
      const camp = this.listings.landings.find((c) => c.id === firstId);
      return (camp && (camp.landing || camp.name || camp.nombre)) || firstId;
    },

    getAreaNegocioLabel() {
      if (!this.hasAreasNegocio) return "";

      const firstId = this.areasNegocioIds[0];
      const list = Array.isArray(this.listings.areasNegocios)
        ? this.listings.areasNegocios
        : [];

      const area = list.find((a) => Number(a.id) === Number(firstId));
      return (area && area.nombre) || "Sin asignar";
    },

    getEmpresaLabel() {
      const items = this.personalData.empresas || [];
      if (!items.length) return "";

      const first = items[0];
      let label = "";

      // Caso 1: viene como objeto
      if (first && typeof first === "object") {
        label = first.empresa || first.nombre || first.name || first.id;
      } else {
        // Caso 2: viene como ID (number/string)
        const emp = this.listings.empresas.find((e) => e.id === first);
        label = (emp && (emp.empresa || emp.nombre || emp.name)) || first;
      }

      return label;
    },

    getCuentaCorreoLabel() {
      const cuentas = this.personalData.cuentas_correo || [];
      if (!cuentas.length) return "";

      const first = cuentas[0];

      // Caso 1: viene objeto desde la BD
      if (typeof first === "object") {
        return first.cuenta || first.nombre || first.id;
      }

      // Caso 2: viene como ID
      const found = this.listings.cuentasCorreo.find((c) => c.id === first);

      return (found && (found.cuenta || found.nombre || found.id)) || first;
    },
    getLandingLabel() {
      const ids = this.personalData.landings || [];
      if (!ids.length) return "";

      const firstId = ids[0];
      const camp = this.listings.landings.find((c) => c.id === firstId);
      return (camp && (camp.landing || camp.name || camp.nombre)) || firstId;
    },
    getCanalLabel() {
      const ids = this.personalData.canales || this.personalData.canal || [];
      if (!ids.length) return "";

      const firstId = ids[0];
      const canalList = this.listings.canalList || [];
      const canal = canalList.find((c) => c.id === firstId);

      return (
        (canal && (canal.etiqueta || canal.nombre || canal.name)) || firstId
      );
    },
  },
};
</script>

<style scoped>
.text-header-data {
  color: #00a7e4;
}

@media (max-width: 959px) {
  .mobile-container {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background-color: #f9f9f9;
    border-radius: 8px;
  }

  .mobile-action-button {
    background-color: #00a7e4 !important;
    color: white;
    font-weight: bold;
    width: 100%;
    max-width: 300px;
  }
}
.pill-tag {
  display: inline-block;
  padding: 4px 16px;
  border-radius: 999px;
  background-color: #00a7e4;
  color: #ffffff;
  font-size: 12px;
  font-weight: 500;
}

.pill-extra {
  margin-left: 8px;
  font-size: 12px;
  color: #777777;
}
</style>
